import { publicRequest } from '../../../util/SuperagentUtils';
import { freightPlaceRequests } from '../../../requests/api-endpoints';
import type { FreightPlace } from '../../../types/FreightPlace';

/** Every port and rail ramp; the same list for everyone, cached by the browser for a day. */
export const getFreightPlaces = (): Promise<FreightPlace[]> =>
  publicRequest.get(freightPlaceRequests.list).then(({ body }) => body);
